import typography from '../typography'
export default {
  root: {
    padding: '16px 24px'
  },
  title: typography.h6

};
